import React, { lazy, Suspense, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch } from 'react-router-dom';
import { LayoutDefault } from 'src/app/layouts';
import { reduxRootTypes } from 'src/types';
import styles from 'src/app/components/ETECubeSection/ETECubeSection.module.scss';
import { errorLocals } from 'src/locals';
import { contentActions, contentsActions, eventActions, mapActions, unitsActions } from 'src/app/redux/actions';
import { statusHelper, storageHelper } from 'src/app/helpers';
import { axios, axiosc } from 'src/app/utils';
import { isNumber } from 'lodash';

import {
  CreateDatabaseEventDataType,
  EventResultType,
  ReplicateEventDataType,
} from 'src/types/services/events-service.type';
import {
  denizAraciParametreleriService,
  emirService,
  etmenService,
  etmenSiniflariService,
  etmenTurleriService,
  eventService,
  havaAraciParametreleriService,
  ikmalSiniflariService,
  insanYapimiEngelTuruService,
  layersServerService,
  muharebeCihazlariService,
  muhimmatIndekslerService,
  taraflarService,
  tmkKalemiOzellikleriService,
} from 'src/app/services';

import { AuthorizedPlayerRoute } from '..';
import { OntologyAndFlowOptionType } from './etecube-section.config';

import { generator } from 'src/app/helpers/map-unit-generator.helper';
import { MapUnit, UnitSide } from 'src/types/unit.type';

import { checkPermissionList } from 'src/app/helpers/permissions.helper';
import { PermissionEnum } from 'src/enums/permission.enum';

import PasswordChangeForm from '../Forms/PasswordChangeForm/PasswordChangeForm';
import SessionTimeout from '../SessionTimeout/SessionTimeout';
import useLogout from 'src/app/hooks/useLogout';
import { layers } from 'src/app/controllers/LayersController/config';

const Experimentation = lazy(() => import('src/app/pages/Experimentation/Experimentation'));
const FlowManagement = lazy(() => import('src/app/pages/FlowManagement/FlowManagement'));
const ObjectiveManagement = lazy(() => import('src/app/pages/ObjectiveManagement/ObjectiveManagement'));
const RealLifeSupport = lazy(() => import('src/app/pages/RealLifeSupport/RealLifeSupport'));
const Lill = lazy(() => import('src/app/pages/Lill/Lill'));
const SSM = lazy(() => import('src/app/pages/SSM/SSM'));
const PPM = lazy(() => import('src/app/pages/PPM/PPM'));
const ODC2M = lazy(() => import('src/app/pages/ODC2M/ODC2M'));
const COAM = lazy(() => import('src/app/pages/COAM/COAM'));
const HelpAndSupport = lazy(() => import('src/app/pages/Lill/Lill'));

import Ontology from 'src/app/pages/Administration/Administration';

import { allCOAMReadPermissions, allODC2MReadPermissions, allPPMReadPermissions } from '../Sidebar/sidebar.config';
import AdvancedDatabaseOptions from '../Misc/AdvancedDatabaseOptions';

import ProductLicenses from 'src/app/pages/ProductLicenses/ProductLicenses';
import { useTranslation } from 'react-i18next';
import message from 'antd/es/message';
import Modal from 'antd/es/modal/Modal';
import Spin from 'antd/es/spin';
import Button from 'antd/es/button';
import Form from 'antd/es/form';
import Input from 'antd/es/input';

const ETECubeSection = () => {
  const { t } = useTranslation();

  const defaultNewEventData: ReplicateEventDataType = {
    flowOptionSelectedEventId: '',
    ontologyOptionSelectedEventId: '',
    replicateEventId: '',
    eventId: '',
    eventName: '',
    eventClassification: '',
    hymotsDB: 0,
  };

  const defaultNewCreateEventData: CreateDatabaseEventDataType = {
    eventId: '',
    eventName: '',
    eventClassification: '',
    hymotsDB: 0,
    flowOption: {
      type: OntologyAndFlowOptionType.DEFAULT,
      fromEventId: '',
    },
    ontologyOption: {
      type: OntologyAndFlowOptionType.DEFAULT,
      fromEventId: '',
    },
  };

  const userState = useSelector((state: reduxRootTypes.RootStateType) => state.userState);
  const eventState = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);
  const { stateNodeList } = useSelector((state: reduxRootTypes.RootStateType) => state.stateFlowState);
  const { eventList } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);
  const { eventId, hymotsDB } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);
  const { localpermissions } = useSelector((state: reduxRootTypes.RootStateType) => state.userRolePermissionState);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showModes, setShowModes] = useState(false);
  const [choosenMap, setChoosenMap] = useState<string>('');
  const [changePasswordModal, setChangePasswordModal] = useState<boolean>(!userState.isRegistered);

  const [eventSelected, setEventSelected] = useState(false);
  const [modeSelected, setModeSelected] = useState(false);
  const [newEventForm, setNewEventForm] = useState<ReplicateEventDataType>(defaultNewEventData);
  const [createNewEventForm, setCreateNewEventForm] = useState<CreateDatabaseEventDataType>(defaultNewCreateEventData);

  const [dbType, setDbType] = useState<'new' | 'replicate'>('new');
  const [flowOption, setFlowOption] = useState<OntologyAndFlowOptionType>(OntologyAndFlowOptionType.DEFAULT);
  const [ontologyOption, setOntologyOption] = useState<OntologyAndFlowOptionType>(OntologyAndFlowOptionType.DEFAULT);
  const [newMapOrExistingMap, setNewMapOrExistingMap] = useState('');
  const [allEvent, setAllEvent] = useState<EventResultType[]>([]);
  const [isNetworkPending, setIsNetworkPending] = useState(false);

  const dispatch = useDispatch();
  const logout = useLogout();

  const getEventData = async () => {
    try {
      const eventsOfUser: EventResultType[] = [];
      eventList.forEach((e) => {
        userState.events.forEach((x) => {
          if (e.id === x.id) {
            eventsOfUser.push(e);
          }
        });
      });

      setAllEvent(eventsOfUser);
    } catch (error: any) {
      if (error !== errorLocals.errorHandledError) {
        statusHelper.displayErrorMessage(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    getEventData();
  }, [eventList]);

  function formatDate(date: number) {
    let d;

    if (isNumber(date)) {
      d = new Date(date);
    } else {
      d = new Date(parseInt(date));
    }

    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return [year, month, day].join('-');
  }

  useEffect(() => {
    setIsModalVisible(eventState.eventId === '');
  }, [eventState.eventId]);

  const handleOk = () => {
    // TODO: Fix here
    setIsModalVisible(false);
  };

  const clickOnExistingMap = () => {
    setNewMapOrExistingMap('existing');
  };

  const clickOnNewMap = () => {
    setNewMapOrExistingMap('new');
  };

  const clickOnHorizontal = (target: 'new' | 'existing') => {
    setModeSelected(true);
    setNewMapOrExistingMap(target);
  };

  const chooseGame = (id: string) => {
    setChoosenMap(id);
    setShowModes(!showModes);
  };

  const resetContents = () => {
    dispatch(contentsActions.configurationChangeRequestList([], false));
    dispatch(contentsActions.troubleTicketList([], false));
    dispatch(contentsActions.technicalSupportRequestList([], false));
    dispatch(contentsActions.battleRhythmList([]));

    dispatch(contentsActions.trainingObjectiveList([]));

    dispatch(contentsActions.ontologyList([]));

    dispatch(contentsActions.incidentFolderList([]));
    dispatch(contentsActions.incidentList([]));
    dispatch(contentsActions.injectionList([]));
    dispatch(contentsActions.actionList([]));
    dispatch(contentsActions.observationTaskList([]));

    dispatch(contentsActions.workPackageList([]));
    dispatch(contentsActions.taskList([]));
    dispatch(contentsActions.projectInputList([]));
    dispatch(contentsActions.kanbanList([]));
    dispatch(contentsActions.deliverableList([]));
    dispatch(contentsActions.testList([]));

    dispatch(contentsActions.coaList([]));
    dispatch(contentsActions.phaseList([]));
    dispatch(contentsActions.lineOfEffortList([]));
    dispatch(contentsActions.planOrderReportProcessList([]));
    dispatch(contentsActions.outcomeList([]));
    dispatch(contentsActions.decisiveConditionList([]));
    dispatch(contentsActions.odTaskList([]));
    dispatch(contentsActions.effectList([]));
    dispatch(contentsActions.turnChartList([]));
    dispatch(contentsActions.projectsList([]));
  };

  const handleOnSelect = async () => {
    if (!choosenMap) {
      message.warning(t('general.pleaseselectDatabase'));
    }
    try {
      const { event } = (await eventService.eventSelect({ id: choosenMap })).data;

      if (event) {
        resetContents();

        axios.setEventId(event.id);

        storageHelper.setValueWithKey('eventId', event.id.toString());
        storageHelper.setValueWithKey('veritabaniId', event.hymotsDB?.toString()!);

        dispatch(
          eventActions.eventDataChanged({
            eventClassification: event.eventClassification,
            eventName: event.eventId,
            hymotsDB: event.hymotsDB,
            hlaContent: undefined,
          }),
        );

        dispatch(eventActions.eventIdChanged(event.id));
        dispatch(eventActions.eventTimePreferenceChanged(event.timePreference));

        dispatch(contentsActions.roadToCurrentSettingsList([]));

        // setLocalPermissions(permissionsOfUser);
        setIsModalVisible(false);
      }
    } catch (error) {
      console.log('error :>> ', error);
    }
  };

  const onCreateEventDatabase = async () => {
    setIsNetworkPending(true);
    try {
      if (dbType === 'new') {
        if (
          (flowOption === OntologyAndFlowOptionType.FROM_EVENT && !newEventForm.flowOptionSelectedEventId) ||
          (ontologyOption === OntologyAndFlowOptionType.FROM_EVENT && !newEventForm.ontologyOptionSelectedEventId)
        ) {
          statusHelper.displayErrorMessage(t('administration.event.pleaseSelectADatabaseToImport'));
          setIsNetworkPending(false);
          return;
        } else {
          await createNewEventDatabase(flowOption, ontologyOption);
        }
      } else if (dbType === 'replicate') {
        if (!newEventForm.replicateEventId) {
          statusHelper.displayErrorMessage(t('administration.event.pleaseSelectADatabaseToReplicate'));
          setIsNetworkPending(false);
          return;
        }
        await onReplicateEventDatabase();
      }
      setIsNetworkPending(false);
    } catch (error: any) {
      if (error !== errorLocals.errorHandledError) {
        statusHelper.displayErrorMessage(error.response.data.message);
      }
      setIsNetworkPending(false);
    }
  };

  const onReplicateEventDatabase = async () => {
    try {
      const event = (await eventService.replicateEventDatabase(newEventForm)).data;
      if (event) {
        axios.setEventId(event.id);
        storageHelper.setValueWithKey('eventId', event.id.toString());
        storageHelper.setValueWithKey('veritabaniId', event.hymotsDB?.toString()!);

        dispatch(
          eventActions.eventDataChanged({
            // TODO Change "Game" naming to "Veritabani" globally
            // eventClassification: 'NON SENSITIVE', // TODO add to DB
            eventClassification: event.eventClassification, // TODO add to DB
            eventName: event.eventId,
            hymotsDB: event.hymotsDB,
            hlaContent: undefined,
          }),
        );

        dispatch(eventActions.eventAdded({ ...event, forbiddenModules: [] }));

        dispatch(eventActions.eventIdChanged(event.id));
        dispatch(eventActions.eventTimePreferenceChanged(event.timePreference));
        setIsModalVisible(false);
      }
    } catch (error: any) {
      if (error !== errorLocals.errorHandledError) {
        statusHelper.displayErrorMessage(error.response.data.message);
      }
    }
  };

  const createNewEventDatabase = async (
    flowType: OntologyAndFlowOptionType = 1,
    ontologyType: OntologyAndFlowOptionType = 1,
  ) => {
    try {
      const dataToCreateDatabase = {
        ...createNewEventForm,
        flowOption: {
          type: flowType,
          fromEventId:
            flowOption === OntologyAndFlowOptionType.FROM_EVENT ? newEventForm.flowOptionSelectedEventId : '',
        },
        ontologyOption: {
          type: ontologyType,
          fromEventId:
            ontologyOption === OntologyAndFlowOptionType.FROM_EVENT ? newEventForm.ontologyOptionSelectedEventId : '',
        },
      };

      const event = (await eventService.createEventDatabase(dataToCreateDatabase)).data;
      if (event) {
        axios.setEventId(event.id);
        storageHelper.setValueWithKey('eventId', event.id.toString());
        storageHelper.setValueWithKey('veritabaniId', event.hymotsDB?.toString()!);

        dispatch(
          eventActions.eventDataChanged({
            // TODO Change "Game" naming to "Veritabani" globally
            // eventClassification: 'NON SENSITIVE', // TODO add to DB
            eventClassification: event.eventClassification, // TODO add to DB
            eventName: event.eventId,
            hymotsDB: event.hymotsDB,
            hlaContent: undefined,
          }),
        );

        dispatch(eventActions.eventAdded({ ...event, forbiddenModules: [] }));

        dispatch(eventActions.eventIdChanged(event.id));
        dispatch(eventActions.eventTimePreferenceChanged(event.timePreference));

        setIsModalVisible(false);
      } else {
        console.log('No event');
      }
    } catch (error: any) {
      if (error !== errorLocals.errorHandledError) {
        statusHelper.displayErrorMessage(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    if (eventState.eventId !== '') {
      setEventSelected(true);
    }
  }, [eventState.eventId]);

  useEffect(() => {
    if (
      flowOption !== OntologyAndFlowOptionType.FROM_EVENT ||
      ontologyOption !== OntologyAndFlowOptionType.FROM_EVENT
    ) {
      setNewEventForm({
        ...newEventForm,
        flowOptionSelectedEventId: '',
        ontologyOptionSelectedEventId: '',
      });
    }
  }, [flowOption, ontologyOption]);

  const onFormChange = (inputLabel: string, value: string) => {
    switch (inputLabel) {
      case 'replicateEventId':
        setNewEventForm({
          ...newEventForm,
          replicateEventId: value,
        });
        break;
      case 'flowOptionSelectedEventId':
        setNewEventForm({
          ...newEventForm,
          flowOptionSelectedEventId: value,
        });
        break;
      case 'ontologyOptionSelectedEventId':
        setNewEventForm({
          ...newEventForm,
          ontologyOptionSelectedEventId: value,
        });
        break;
      case 'eventId':
        setCreateNewEventForm({
          ...createNewEventForm,
          eventId: value,
        });
        setNewEventForm({
          ...newEventForm,
          eventId: value,
        });
        break;
      case 'eventName':
        setCreateNewEventForm({
          ...createNewEventForm,
          eventName: value,
        });
        setNewEventForm({
          ...newEventForm,
          eventName: value,
        });
        break;
      case 'eventClassification':
        setCreateNewEventForm({
          ...createNewEventForm,
          eventClassification: value,
        });
        setNewEventForm({
          ...newEventForm,
          eventClassification: value,
        });
        break;

      default:
    }
  };

  useEffect(() => {
    if (hymotsDB) {
      axiosc.setEventId(hymotsDB.toString());
      getDataAndSetUnits();
    } else {
      dispatch(contentActions.setAircrafts([]));
      dispatch(contentActions.setNavalcrafts([]));
      dispatch(contentActions.setObstacles([]));
      dispatch(contentActions.setSupplies([]));
      dispatch(contentActions.setSystems([]));
      dispatch(contentActions.setAmmoIndexes([]));
      dispatch(contentActions.setCommands([]));
      dispatch(contentActions.setCommDevices([]));
      dispatch(contentActions.setSides([]));
      dispatch(unitsActions.setUnits([]));
    }
  }, [hymotsDB]);

  /* hymotsc get db datas*/
  const getDataAndSetUnits = async () => {
    try {
      const {
        data: { rows: etmenler },
      } = await etmenService.etmenLookup({ blockSpinner: true });

      const {
        data: { rows: etmenTurleri },
      } = await etmenTurleriService.etmenTurleriMapLookup({ blockSpinner: true });
      const {
        data: { rows: etmenSiniflari },
      } = await etmenSiniflariService.etmenSiniflariLookup({ blockSpinner: true });
      const {
        data: { rows: taraflar },
      } = await taraflarService.taraflarLookup({ blockSpinner: true });
      const {
        data: { rows: ikmaller },
      } = await ikmalSiniflariService.ikmalSiniflariLookup({ blockSpinner: true }); // ikmaller

      const {
        data: { rows: mapTmklar },
      } = await tmkKalemiOzellikleriService.tmkKalemiOzellikleriMapLookup({ blockSpinner: true }); //tmklar

      const {
        data: { rows: muhimmatIndeksler },
      } = await muhimmatIndekslerService.muhimmatIndekslerLookup({ blockSpinner: true });
      const {
        data: { rows: havaAraclari },
      } = await havaAraciParametreleriService.havaAraciParametreleriLookup({ blockSpinner: true });

      const {
        data: { rows: denizAraclari },
      } = await denizAraciParametreleriService.denizAraciParametreleriLookup({ blockSpinner: true });

      const {
        data: { rows: engeller },
      } = await insanYapimiEngelTuruService.insanYapimiEngelTuruLookup({ blockSpinner: true });
      const {
        data: { rows: muhabereCihazlari },
      } = await muharebeCihazlariService.muharebeCihazlariLookup({ blockSpinner: true });

      const {
        data: { rows: emirData },
      } = await emirService.emirLookup({ blockSpinner: true });

      const {
        data: { rows: emirGruplariData },
      } = await emirService.emirGruplariLookup({ blockSpinner: true });

      dispatch(contentActions.setAircrafts(havaAraclari));
      dispatch(contentActions.setNavalcrafts(denizAraclari));
      dispatch(contentActions.setObstacles(engeller));
      dispatch(contentActions.setSupplies(ikmaller));
      dispatch(contentActions.setSystems(mapTmklar));
      dispatch(contentActions.setAmmoIndexes(muhimmatIndeksler));
      dispatch(contentActions.setCommands(emirData));
      dispatch(contentActions.setCommandGroups(emirGruplariData));
      dispatch(contentActions.setCommDevices(muhabereCihazlari));
      dispatch(contentActions.setSides(taraflar));
      dispatch(contentActions.setFactions(etmenSiniflari));
      dispatch(contentActions.setPrototypes(etmenTurleri));
      dispatch(contentActions.setAgents(etmenler));
      dispatch(contentActions.setObstacles(engeller));

      dispatch(unitsActions.setSides(taraflar));
      dispatch(unitsActions.setFactions(etmenSiniflari));
      dispatch(unitsActions.setPrototypes(etmenTurleri));
      dispatch(unitsActions.setObstacles(engeller));

      const localUnits: MapUnit[] = [];
      const localSides: UnitSide[] = [];

      if (etmenler) {
        etmenler.forEach((etmen) => {
          const unit = generator(etmen, etmenTurleri, etmenSiniflari, taraflar, engeller);

          if (!unit) return;

          if (!localSides.find((item) => item.id === unit.taraf?.id) && unit.taraf) {
            localSides.push(unit.taraf);
          }

          localUnits.push(unit);
        });
      }

      dispatch(unitsActions.setUnits(localUnits));
      dispatch(contentActions.setActiveSides(localSides));
    } catch (error) {
      console.log('error :>> ', error);
    }
  };

  useEffect(() => {
    try {
      const eventCheck = (eventId: string) => {
        const eventData = eventList.find((e) => e.id === eventId);

        if (!eventData) return;

        dispatch(eventActions.eventTimePreferenceChanged(eventData.timePreference));

        dispatch(
          eventActions.eventDataChanged({
            eventClassification: eventData.eventClassification,
            eventName: eventData.eventId,
            hymotsDB: eventData.hymotsDB,
            hlaContent: eventData.HLAContent,
          }),
        );
      };
      if (eventId) {
        eventCheck(eventId);
      }
    } catch (error) {
      console.log('error :>> ', error);
    }
  }, [eventId, eventList]);

  const getLayers = async () => {
    try {
      const { data } = await layersServerService.getLayers();
      dispatch(mapActions.setAvailableLayers(data));
    } catch (error: any) {
      console.error('Failed to fetch layer settings from Layer Server: ', error);
      dispatch(mapActions.setAvailableLayers(layers));
      console.warn('Setting default layers ');
    }
  };

  useEffect(() => {
    getLayers();
  }, []);

  return (
    <>
      <SessionTimeout
        onActive={() => {}}
        onIdle={() => {
          logout();
        }}
        userState={userState}
        // timeOutInterval={userState.sessionTime ? userState.sessionTime * 1000 : undefined}
      />

      {localpermissions.length > 0 && eventSelected && stateNodeList.length > 0 ? (
        <LayoutDefault>
          <Suspense fallback={<div>Loading...</div>}>
            <Switch>
              <AuthorizedPlayerRoute
                exact
                authenticated={userState.authenticated}
                userRoleId={userState.userRoles}
                path="/ObjectiveManagement"
                component={ObjectiveManagement}
                pathpermission={[11001, 18001]}
              />
              <AuthorizedPlayerRoute
                exact
                authenticated={userState.authenticated}
                userRoleId={userState.userRoles}
                path="/FlowManagement"
                component={FlowManagement}
                pathpermission={[5001, 6001, 7001, 8001, 9001, 10001, 19001, 20001]}
              />
              <AuthorizedPlayerRoute
                exact
                authenticated={userState.authenticated}
                userRoleId={userState.userRoles}
                path="/RealLifeSupport"
                component={RealLifeSupport}
                pathpermission={[15001, 16001, 22001, 23001]}
              />
              <AuthorizedPlayerRoute
                exact
                authenticated={userState.authenticated}
                userRoleId={userState.userRoles}
                path="/Experimentation"
                component={Experimentation}
                pathpermission={[17001]}
              />
              <AuthorizedPlayerRoute
                exact
                authenticated={userState.authenticated}
                userRoleId={userState.userRoles}
                path="/Lill"
                component={Lill}
                pathpermission={[21001]}
              />
              <AuthorizedPlayerRoute
                exact
                authenticated={userState.authenticated}
                userRoleId={userState.userRoles}
                path="/SSM"
                component={SSM}
                pathpermission={[1001, 25001, 26001, 26002]}
              />
              <AuthorizedPlayerRoute
                exact
                authenticated={userState.authenticated}
                userRoleId={userState.userRoles}
                path="/PPM"
                component={PPM}
                pathpermission={allPPMReadPermissions}
              />
              <AuthorizedPlayerRoute
                exact
                authenticated={userState.authenticated}
                userRoleId={userState.userRoles}
                path="/COAM"
                component={COAM}
                pathpermission={allCOAMReadPermissions}
              />
              <AuthorizedPlayerRoute
                exact
                authenticated={userState.authenticated}
                userRoleId={userState.userRoles}
                path="/ODC2M"
                component={ODC2M}
                pathpermission={allODC2MReadPermissions}
              />

              <AuthorizedPlayerRoute
                exact
                authenticated={userState.authenticated}
                userRoleId={userState.userRoles}
                path="/Administration"
                component={Ontology}
                pathpermission={[1001, 2001, 3001, 4001, 24001]}
              />
              <AuthorizedPlayerRoute
                exact
                authenticated={userState.authenticated}
                userRoleId={userState.userRoles}
                path="/HelpAndSupport"
                component={HelpAndSupport}
                pathpermission={[]}
              />
              <AuthorizedPlayerRoute
                exact
                authenticated={userState.authenticated}
                userRoleId={userState.userRoles}
                path="/ProductLicenses"
                component={ProductLicenses}
                pathpermission={[]}
              />
            </Switch>
          </Suspense>
        </LayoutDefault>
      ) : (
        eventState.eventId &&
        userState.isRegistered && (
          <LayoutDefault>
            <div className={styles.loadingContainer}>
              <Spin size="large" />
            </div>
          </LayoutDefault>
        )
      )}

      {!eventState.eventId && userState.isRegistered && (
        <LayoutDefault>
          <Modal
            visible={isModalVisible}
            width={750}
            className={styles.modal}
            onOk={handleOk}
            closable={false}
            footer={false}
            zIndex={9999}
            mask={false}
            wrapClassName={styles.clickThroughModal}
          >
            <div
              className={styles.mainContainer}
              style={{
                pointerEvents: 'auto',
              }}
            >
              <div className={styles.logoContainer}>
                <img alt="logo" id="etecube-logo" className={styles.logo} src="assets/etecube.png" />
              </div>
              <div className={styles.container}>
                {modeSelected ? (
                  <>
                    <div className={styles.tab}>
                      <div className={styles.tabButtonContainer}>
                        <div className={styles.modeContainer}>
                          <div
                            onClick={() => {
                              if (!checkPermissionList(PermissionEnum.EventCreate)) clickOnNewMap();
                            }}
                            className={
                              checkPermissionList(PermissionEnum.EventCreate)
                                ? styles.notAllowed
                                : newMapOrExistingMap === 'new'
                                ? styles.selectedMode
                                : styles.mode
                            }
                          >
                            <img className={styles.modeImg} src="/assets/newGame.png" alt="execute" />
                          </div>
                          <div className={styles.modeTitle}>{t('general.newEvent')}</div>
                        </div>

                        <div className={styles.modeContainer}>
                          <div
                            onClick={clickOnExistingMap}
                            className={newMapOrExistingMap === 'existing' ? styles.selectedMode : styles.mode}
                          >
                            <img className={styles.modeImg} src="/assets/loadGame.png" alt="design" />
                          </div>
                          <div className={styles.modeTitle}>{t('general.existingDatabase')}</div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.content}>
                      {allEvent && newMapOrExistingMap === 'existing' && (
                        <>
                          <div style={{ height: '300px', overflow: 'auto' }}>
                            {allEvent.map((event) => (
                              <div key={event.id}>
                                <div
                                  data-game={event.eventId}
                                  className={
                                    event.id === choosenMap ? styles.choosenGameContainer : styles.gameContainer
                                  }
                                  onClick={() => chooseGame(event.id)}
                                >
                                  <div>
                                    <span className={styles.gameName}>{event.eventId}</span>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className={styles.footer}>
                            <Button className="modal-button" key="submit" type="primary" onClick={handleOnSelect}>
                              {t('general.load')}
                            </Button>
                          </div>
                        </>
                      )}
                      {newMapOrExistingMap === 'new' && (
                        <Form initialValues={newEventForm} onFinish={onCreateEventDatabase} validateTrigger="onFinish">
                          <div className={styles.newMapContainer}>
                            <div className={styles.newMapFirstPart}>
                              <Form.Item
                                name="eventId"
                                rules={[{ required: true, message: t('general.required') || '' }]}
                              >
                                <div className={styles.inputContainer}>
                                  <span>{t('general.eventId')}</span>
                                  <Input
                                    onChange={(e) => onFormChange('eventId', e.target.value)}
                                    className={styles.input}
                                  />
                                </div>
                              </Form.Item>
                              <Form.Item
                                name="eventName"
                                rules={[{ required: true, message: t('general.required') || '' }]}
                              >
                                <div className={styles.inputContainer}>
                                  <span>{t('administration.event.eventName')}</span>
                                  <Input
                                    onChange={(e) => onFormChange('eventName', e.target.value)}
                                    className={styles.input}
                                  />
                                </div>
                              </Form.Item>
                              <Form.Item name="classification" rules={[{ required: false }]}>
                                <div className={styles.inputContainer}>
                                  <span>{t('administration.event.eventClassification')}</span>
                                  <Input
                                    className={styles.input}
                                    onChange={(e) => onFormChange('eventClassification', e.target.value)}
                                  />
                                </div>
                              </Form.Item>

                              <Form.Item name="flowOptions" rules={[{ required: false }]}>
                                <AdvancedDatabaseOptions
                                  dbType={dbType}
                                  setDbType={setDbType}
                                  flowOption={flowOption}
                                  setFlowOption={setFlowOption}
                                  ontologyOption={ontologyOption}
                                  setOntologyOption={setOntologyOption}
                                  allEvent={allEvent}
                                  onFormChange={onFormChange}
                                />
                              </Form.Item>
                            </div>
                            <Button
                              className={styles.createDatabaseButton}
                              key="submit"
                              htmlType="submit"
                              type="primary"
                              loading={isNetworkPending}
                            >
                              {t('administration.event.createDatabase')}
                            </Button>
                          </div>
                        </Form>
                      )}
                    </div>
                  </>
                ) : (
                  <div className={styles.horizontalTabs}>
                    <div className={styles.tabButtonContainerHorizontal}>
                      <div className={styles.modeContainer}>
                        <div
                          onClick={() => {
                            if (!checkPermissionList(PermissionEnum.EventCreate)) clickOnHorizontal('new');
                          }}
                          className={
                            checkPermissionList(PermissionEnum.EventCreate)
                              ? styles.notAllowed
                              : newMapOrExistingMap === 'new'
                              ? styles.selectedMode
                              : styles.mode
                          }
                        >
                          <img className={styles.modeImg} src="/assets/newGame.png" alt="execute" />
                        </div>
                        <div className={styles.modeTitle}>{t('general.newEvent')}</div>
                      </div>

                      <div className={styles.modeContainer}>
                        <div
                          onClick={() => clickOnHorizontal('existing')}
                          className={newMapOrExistingMap === 'existing' ? styles.selectedMode : styles.mode}
                        >
                          <img className={styles.modeImg} src="/assets/loadGame.png" alt="design" />
                        </div>
                        <div className={styles.modeTitle}>{t('general.existingDatabase')}</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Modal>
        </LayoutDefault>
      )}

      {!eventState.eventId && !userState.isRegistered && (
        <LayoutDefault>
          <PasswordChangeForm isModalOpen={changePasswordModal} setIsModalOpen={setChangePasswordModal} />
        </LayoutDefault>
      )}
    </>
  );
};

export default ETECubeSection;
